const DISCIPLINE_TYPES = {
  HISTORIAL_DEL_DESARROLLO: 22,
  INFORME_ACADEMICO: 23,
  Educativo: 126,
  AsistenciaTecnologia: 704,
  AutismoInfantilAd: 716,
  AutismoInfantilIn: 1755,
  ABA: 1772,
  EducacionFisicaAdaptada: 721,
  EducacionVocacional: 1780,
  EducacionVocacionalPreliminar: 1826,
  EducacionVocacionalFinal: 1827,
  FisicaAdaptada: 1786,
  Ocupacional: 690,
  EvaluacionVocacionalPreliminar: 1826,
  EvaluacionVocacionalFinal: 1827,
};

export default DISCIPLINE_TYPES;
